module.exports = __webpack_public_path__ + "img/logo_drugs.f0975996.png";